// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__Umceq","disabled":"styles_disabled__ais6E","lightBtn":"styles_lightBtn__KJF4d"};